// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import Link from '@mui/material/Link';

// Section for import custom components --------------------------------------------------------------------------------

// Section for render component ----------------------------------------------------------------------------------------

// Section for type definition -----------------------------------------------------------------------------------------
import MansionContractHistoryPropsData from '@/types/components/MansionDetail/MansionContractHistoryPropsData';
import MansionRenovationHistoriesPropsData from '@/types/components/MansionDetail/MansionRenovationHistoriesPropsData';

type MansionLabelProps = {
  mansionContractHistory: MansionContractHistoryPropsData[];
  mansionRenovationHistory: MansionRenovationHistoriesPropsData[];
};

export default function MansionLabel(props: MansionLabelProps) {
  const { mansionContractHistory, mansionRenovationHistory } = props;

  // 両方のデータが存在しない場合は表示しない
  if (!mansionContractHistory && !mansionRenovationHistory) {
    return null;
  }
  return (
    <Container className="md:max-w-7xl md:w-full md:mx-auto md:px-24 max-md:px-5 py-3 max-md:py-3">
      <Box className="flex gap-x-3">
        {mansionContractHistory && (
          <Link href="#mansionContractHistory" className="no-underline md:hover:opacity-80 md:transition-opacity">
            <Box className="flex items-center gap-x-[3px] px-3 max-md:px-2 py-[6px] max-md:py-1  bg-[#DCF0F0] border-[1px] border-rf-navy rounded-lg">
              <HandshakeRoundedIcon className="text-rf-navy text-lg" />
              <Typography className="text-sm max-md:text-xs font-bold text-rf-navy">仲介実績あり</Typography>
            </Box>
          </Link>
        )}
        {mansionRenovationHistory && (
          <Link
            href="#mansionRenovationHistoryPreview"
            className="no-underline md:hover:opacity-80 md:transition-opacity"
          >
            <Box className="flex items-center gap-x-[3px] px-3 max-md:px-2 py-[6px] max-md:py-1  bg-[#FFECEC] border-[1px] border-rf-red rounded-lg">
              <HomeRoundedIcon className="text-rf-red text-lg" />
              <Typography className="text-sm max-md:text-xs font-bold text-rf-red">リノベ実績あり</Typography>
            </Box>
          </Link>
        )}
      </Box>
    </Container>
  );
}
